import { useEffect, useState } from "react";
import Navbar from "../Navbar.jsx";
import Footer from "../Foooter.jsx";
import SearchBar from "../SearchBar.jsx";
import MenuStock from "../menustocksubastas.jsx";
import "../../style/Stock.css";
import "../../style/ModalDelete.css";
import api from "../../utils/apiClient";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate, Link } from "react-router-dom";
import FooterMovil from "../FooterMovil.jsx";

function Subastas() {
  const { authToken, logout } = useAuth();
  const [marcas, setMarcas] = useState([]);
  const [allmodelos, setAllModelos] = useState([]);
  // null = show all; { matches, query } = active in-place filter.
  const [auctionFilter, setAuctionFilter] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false);

  const navigate = useNavigate();

  // Brand/model lists feed the SearchBar's suggestions + parsing.
  useEffect(() => {
    const getMarcas = async () => {
      try {
        const res = await api.get("marcasymodelos/marca");
        setMarcas(res.data.map((c) => c.Nombre));
      } catch (error) {
        console.error("Error fetching marcas:", error);
      }
    };
    const getModelosAll = async () => {
      try {
        const res = await api.get("marcasymodelos/modelo");
        setAllModelos(res.data.map((m) => m.Nombre));
      } catch (error) {
        console.error("Error fetching modelos:", error);
      }
    };
    Promise.all([getMarcas(), getModelosAll()]);
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await api.get("usuario/getbyToken");
        setShowVerificationModal(!res.data.verficado);
      } catch (error) {
        console.error("Error fetching user:", error);
        logout();
      }
    };

    if (!authToken) {
      setShowLoginModal(true);
      setShowVerificationModal(false);
    } else {
      setShowLoginModal(false);
      fetchUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken]);

  // Searching filters the auctions in place (client-side) rather than leaving
  // the page; an empty search (or "Ver todos") clears the filter.
  const handleAuctionSearch = (matches, query) => {
    if ((!matches || matches.length === 0) && !query) {
      setAuctionFilter(null);
    } else {
      setAuctionFilter({ matches, query });
    }
  };

  const handleShowAllAuctions = () => setAuctionFilter(null);

  return (
    <>
      <Navbar />
      <div className="search-bar">
        <SearchBar
          marcas={marcas}
          allmodelos={allmodelos}
          onSearch={handleAuctionSearch}
          onShowAll={handleShowAllAuctions}
          placeholder="Marca, modelo, año, lote, ubicación..."
          className="subastas-search"
        />
      </div>
      {authToken && (
        <div className="misofertas-linkrow">
          <Link to="/misofertas" className="misofertas-link">
            Mis ofertas →
          </Link>
        </div>
      )}

      <div className="stock-view">
        <div className="menu-stock">
          <MenuStock filter={auctionFilter} />
        </div>
      </div>

      <div className="footer">
        <Footer />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>

      {showLoginModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <p>Debes iniciar sesión para participar en las subastas</p>
            <button className="red-button" onClick={() => navigate("/login")}>
              Iniciar sesión
            </button>
          </div>
        </div>
      )}
      {showVerificationModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <p>Verificación de usuario es requerida</p>
            <button
              className="red-button"
              onClick={() => navigate("/verificar")}
            >
              Verificar ahora
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Subastas;
